/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2024-02-04 11:04:43
 * @LastEditTime : 2024-02-04 11:09:35
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb1\src\utils\debounce.js
 */
export default {
    install(Vue) {
        Vue.directive("debounce", {
            // bind 指令第一次绑定到元素时调用。在这里可以进行一次性的初始化设置,比如我们可以设置样式
            bind(el) {
                console.log(el)
            },
            // 被绑定的元素插入到父节点时
            inserted(el, binding) {
                el.addEventListener('click', function () {
                    let time = binding.value.time;
                    let methods = binding.value.methods;
                    clearTimeout(el.timeId)
                    el.timeId = setTimeout(() => {
                        methods()
                    }, time);
                })
            }
        })
    }
}
